export const apiUrl= "https://be.hhco.epay.teceads.co.in/api/v1"
// export const apiUrl= "https://backend.mayifind.teceads.co.in/api/v1"
// export const apiUrl= "http://localhost:5551/api/v1"
// export const apiUrl= "http://192.168.1.20:5551/api/v1"
// export const apiUrl= "http://192.168.1.18:5551/api/v1"
// export const apiUrl = 'https://backend.epay.bmc.teceads.co.in/api/v1'

